import Action  from './baseActions';
import {Favorite} from '../../models';

// Types

export enum FavoriteActionTypes {
  LOAD_FAVORITES = 'favorite/load_favorites',
  LOADING_FAVORITES = 'favorite/loading_favorites',
  LOADED_FAVORITES = 'favorite/loaded_favorites',
  LOADING_FAVORITES_FAILED = 'favorite/loading_favorites_failed',

  CREATE_FAVORITE = 'favorite/create_favorite',
  CREATING_FAVORITE = 'favorite/creating_favorite',
  CREATED_FAVORITE = 'favorite/created_favorite',
  CREATING_FAVORITE_FAILED = 'favorite/creating_favorite_failed',

  DELETE_FAVORITE = 'favorite/delete_favorite',
  DELETING_FAVORITE = 'favorite/deleting_favorite',
  DELETED_FAVORITE = 'favorite/deleted_favorite',
  DELETING_FAVORITE_FAILED = 'favorite/deleting_favorite_failed',
}

// Interfaces

export interface LoadFavoritesAction extends Action {
  type: FavoriteActionTypes.LOAD_FAVORITES;
  payload?: any;
}

export interface LoadingFavoritesAction extends Action {
  type: FavoriteActionTypes.LOADING_FAVORITES;
}

export interface LoadedFavoritesAction extends Action {
  type: FavoriteActionTypes.LOADED_FAVORITES;
  payload: any;
}

export interface LoadingFavoritesFailedAction extends Action {
  type: FavoriteActionTypes.LOADING_FAVORITES_FAILED;
}

export interface CreateFavoriteAction extends Action {
  type: FavoriteActionTypes.CREATE_FAVORITE;
  payload: Partial<Favorite>;
}

export interface CreatingFavoriteAction extends Action {
  type: FavoriteActionTypes.CREATING_FAVORITE;
}

export interface CreatedFavoriteAction extends Action {
  type: FavoriteActionTypes.CREATED_FAVORITE;
  payload: any;
}

export interface CreatingFavoriteFailedAction extends Action {
  type: FavoriteActionTypes.CREATING_FAVORITE_FAILED;
}

export interface DeleteFavoriteAction extends Action {
  type: FavoriteActionTypes.DELETE_FAVORITE;
  payload: string;
}

export interface DeletingFavoriteAction extends Action {
  type: FavoriteActionTypes.DELETING_FAVORITE;
}

export interface DeletedFavoriteAction extends Action {
  type: FavoriteActionTypes.DELETED_FAVORITE;
  payload: string;
}

export interface DeletingFavoriteFailedAction extends Action {
  type: FavoriteActionTypes.DELETING_FAVORITE_FAILED;
}

// Functions

export function loadFavorites(): LoadFavoritesAction {
  return {
    type: FavoriteActionTypes.LOAD_FAVORITES,
  };
}

export function loadingFavorites(): LoadingFavoritesAction {
  return {
    type: FavoriteActionTypes.LOADING_FAVORITES,
  };
}

export function loadedFavorites(result: any): LoadedFavoritesAction {
  return {
    type: FavoriteActionTypes.LOADED_FAVORITES,
    payload: {
      result,
    },
  };
}

export function loadingFavoritesFailed(): LoadingFavoritesFailedAction {
  return {
    type: FavoriteActionTypes.LOADING_FAVORITES_FAILED,
  }
}

export function createFavorite(favorite: Partial<Favorite>): CreateFavoriteAction {
  return {
    type: FavoriteActionTypes.CREATE_FAVORITE,
    payload: favorite,
  };
}

export function creatingFavorite(): CreatingFavoriteAction {
  return {
    type: FavoriteActionTypes.CREATING_FAVORITE,
  };
}

export function createdFavorite(favorite: any): CreatedFavoriteAction {
  return {
    type: FavoriteActionTypes.CREATED_FAVORITE,
    payload: favorite,
  };
}

export function creatingFavoriteFailed(): CreatingFavoriteFailedAction {
  return {
    type: FavoriteActionTypes.CREATING_FAVORITE_FAILED,
  };
}

export function deleteFavorite(uid: string): DeleteFavoriteAction {
  return {
    type: FavoriteActionTypes.DELETE_FAVORITE,
    payload: uid,
  };
}

export function deletingFavorite(): DeletingFavoriteAction {
  return {
    type: FavoriteActionTypes.DELETING_FAVORITE,
  };
}

export function deletedFavorite(uid: string): DeletedFavoriteAction {
  return {
    type: FavoriteActionTypes.DELETED_FAVORITE,
    payload: uid,
  };
}

export function deletingFavoriteFailed(): DeletingFavoriteFailedAction {
  return {
    type: FavoriteActionTypes.DELETING_FAVORITE_FAILED,
  };
}

export type FavoriteAction =
  LoadFavoritesAction |
  LoadingFavoritesAction |
  LoadedFavoritesAction |
  LoadingFavoritesFailedAction |
  CreateFavoriteAction |
  CreatingFavoriteAction |
  CreatedFavoriteAction |
  CreatingFavoriteFailedAction |
  DeleteFavoriteAction |
  DeletingFavoriteAction |
  DeletedFavoriteAction |
  DeletingFavoriteFailedAction;
